import React from "react";

import { toUpperCaseNoAccent } from 'utils/stringHelper';


import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import Stack from '@mui/material/Stack';

import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';


import Button from '@mui/material/Button';


const AddDecoteRetourExcluDialog = ({ onClose, onClickSave, niveaux }) => {

    const [niveau, setNiveau] = React.useState(0);
    const [code, setCode] = React.useState('');
    

    const save = () => {

        var decoteRetourExclu = {
            niveau: niveau,
            code: code
        };

        onClickSave(decoteRetourExclu);
        onClose();
    };

    return (
        <Dialog open>
            <DialogTitle>Nouvelle exclusion des décôtes au retour</DialogTitle>

            <DialogContent>

                <Stack spacing={2} mt={1}>

                    <TextField
                        id="niveau"
                        name="niveau"
                        label="Niveau"
                        required

                        select
                        SelectProps={{
                            required: true,
                            value: niveau,
                            onChange:e => setNiveau(e.target.value)
                        }}
                    >
                        {niveaux.map(n => <MenuItem key={n.id} value={n.id}>{n.libelle}</MenuItem>)}
                    </TextField>


                <TextField
                    id="code"
                    name="code"
                    label={"Code"}
                    required
                    fullWidth
                    placeholder="Saisir un code"
                    value={code}
                    onChange={e => setCode(toUpperCaseNoAccent(e.target.value))}
                    InputLabelProps={{
                        shrink: true
                    }}
                />


                </Stack>



                

            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Annuler
                </Button>
                <Button
                    onClick={save}
                    variant="contained"
                    color="secondary"
                    disabled={!code}
                >
                    Enregistrer
                </Button>
            </DialogActions>
        </Dialog>
    );
};


export default AddDecoteRetourExcluDialog;
